import { render, staticRenderFns } from "./TableDragBtn.vue?vue&type=template&id=b086b53a&scoped=true"
import script from "./TableDragBtn.vue?vue&type=script&lang=js"
export * from "./TableDragBtn.vue?vue&type=script&lang=js"
import style0 from "./TableDragBtn.vue?vue&type=style&index=0&id=b086b53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b086b53a",
  null
  
)

export default component.exports